import { Div, ModalWindow, Span } from '@tblabs/truffle';
import { DefaultButton } from '../../General/Buttons/DefaultButton';
import { Translations } from '../../../Translations/Translations';
import { Svg } from '../../General/Svg';
import { Icons } from '../../Icons';


export class SavingPictureMoreInfoWindow extends ModalWindow
{
    constructor(_lang: Translations, uniqueClientId: string)
    {
        super(_lang.DetailsAboutServerSaving, true, false, true);
        this.MinWidth(380)

        this.AddContent(
            _lang.SavedPicturesInfo
        )

        this.AddToFooter(
            new Div().DisplayInlineBlock().MarginTop(8).FloatLeft().Append(
                new Svg(Icons.Id).Color("#a8a8a8"),
                new Span(uniqueClientId).Style("font-size: 12px; color: #a8a8a8; margin-left: 4px;"),
            ),
            new DefaultButton("OK", () => this.CloseWindow())
        )

        this.OpenWindow()
    }
}
